/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Tooltip } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import styles from './MyOrdersPageContent.module.scss'
import OrderItemsList from './OrderItemsList/OrderItemsList'
import { BankTransferType, BigOrder } from 'src/core/models'
import { MyOrdersListColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import OrderListHeader from './OrderListHeader/OrderListHeader'
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import { CustomTable, CustomCard, DepositsDetailsModal, Loader, CustomText } from 'src/components'
import {
  getMyOrdersList,
  setSelectedOrders,
  selectCurrencyToken,
  getOrderListSelector,
  getOrderCertificatesSelector,
} from 'src/features'
const THANKS = 'THANKS'

const MyOrdersPageContent: React.FC = () => {
  const { t } = useTranslation()
  const [isNewOrderModalVisible, setIsNewOrderModalVisible] = useState<boolean>(false)
  const [newOrder, setNewOrder] = useState<BankTransferType>(null)
  const dispatch = useAppDispatch()
  const { new_order, cart_order_id, message } = useRouter().query

  const { loading, filtered, list: orderList } = useAppSelector(getOrderListSelector)
  const { loading: loadingDownload } = useAppSelector(getOrderCertificatesSelector)
  const currency_code = useAppSelector(selectCurrencyToken)

  useEffect(() => {
    if (cart_order_id) {
      setTimeout(() => {
        dispatch(getMyOrdersList(0, currency_code))
      }, 7000)
    } else {
      dispatch(getMyOrdersList(0, currency_code))
    }
  }, [dispatch, currency_code])

  useEffect(() => {
    if (new_order && orderList.length > 0) {
      setIsNewOrderModalVisible(true)
      const o = orderList.find(x => x.order.id === Number(new_order))
      const order: BankTransferType = {
        amount: o.order.total,
        currency_token_id: o.order.currency_token,
        internal_reference: o.order.reference
      }
      setNewOrder(order)
    }
  }, [orderList])

  const rowSelectionProps = {
    onChange: (_: any, selectedOrders: BigOrder[]) => {
      dispatch(setSelectedOrders(selectedOrders))
    }
  }

  return <>
    <CustomCard loading={loading}>
      {/* Header */}
      <OrderListHeader ordersLength={filtered.length} />

      {/* Purchase Thanks */}
      {loadingDownload && <Loader />}
      {message === THANKS && <div className='mt-4'>
        <CustomText mark italic label={t('Transactions.TranksMessage')} />
      </div>}
      <Divider />

      {/* Table Content */}
      <CustomTable
        columns={MyOrdersListColumns}
        dataSource={filtered}
        rowKey={(bigOrder: BigOrder) => bigOrder.order.id}
        rowSelection={{ type: 'checkbox', ...rowSelectionProps }}
        expandIconColumnIndex={5}
        expandable={{
          expandedRowRender: (o: BigOrder) => <OrderItemsList orderItems={o.order_items} order={o.order} />,
          expandRowByClick: true,
        }}
        expandIcon={({ expanded, onExpand, record }) =>
          expanded ? (
            <DownOutlined
              className={styles.icon}
              onClick={e => onExpand(record, e)}
            />
          ) : (
            <Tooltip title={t('Transactions.CheckOrderItems')} color={'blue'}>
              <RightOutlined
                className={styles.icon}
                onClick={e => onExpand(record, e)}
              />
            </Tooltip>
          )
        }
      />
    </CustomCard>

    <DepositsDetailsModal
      isModalVisible={isNewOrderModalVisible}
      handleCancel={() => setIsNewOrderModalVisible(false)}
      deposit={newOrder}
    />
  </>
}

export default MyOrdersPageContent
